<template>
    <div>
        <slot
            :should-show="shouldShow"
            :toggle="toggle"
        />
    </div>
</template>

<script>
export default {
    name: 'UiCollapse',
    data() {
        return {
            shouldShow: false,
        };
    },
    methods: {
        toggle() {
            this.shouldShow = !this.shouldShow;
        },
    },
}
</script>
